import { render, staticRenderFns } from "./StarsTable.vue?vue&type=template&id=157b906a&scoped=true&"
import script from "./StarsTable.vue?vue&type=script&lang=js&"
export * from "./StarsTable.vue?vue&type=script&lang=js&"
import style0 from "./StarsTable.vue?vue&type=style&index=0&id=157b906a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157b906a",
  null
  
)

export default component.exports